import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRunTrailNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M21.93 17.78l-9.34-.06-1.941-2.14h1.825l.726.8h7.38v-1.1a1.24 1.24 0 00-.73-1.12l-2.25-.68-.823-1.858-2.165 1.978-.022-.024v-1.784l1.61-1.472-.553-1.249-2.017 1.856V9.093l1.44-1.325-.57-1.288a.22.22 0 00-.19-.12.26.26 0 00-.23.07l-1.89 1.96-1.61-1.7V2.93a.51.51 0 00-.15-.36L7 6.06a1.8 1.8 0 01.2.19l5.37 5.958v1.887l-.06.055-6.27-6.99a.51.51 0 00-.87.32.57.57 0 00.13.41l.988 1.09H4.663L4.5 8.8a1.9 1.9 0 011-3.13l4.91-5.1 1 1.07c.329.349.511.81.51 1.29v3.22l.29.31.9-.9a1.61 1.61 0 012.6.43l2.86 6.42 1.74.53a2.6 2.6 0 011.61 2.38z" />
        <path d="M11.25 14.23H9.424l-1.142-1.26h1.825zm-2.367-2.61l-1.17-1.29H5.887l1.17 1.29zm2.787 10.91l-5.91-6.89-2.99 3.422v-2.06l3-3.432 6.08 7.09 2.46-1.96 1.73 1.72h5.71v1.35h-6.27l-1.27-1.27z" />
      </g>
    </svg>
  )
);
SvgSportsRunTrailNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsRunTrailNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRunTrailNormalSmall;
